import React, { useState } from 'react'
import { HashRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import Home from '../Routes/Home'
import TV from '../Routes/TV'
import Search from '../Routes/Search'
import Detail from '../Routes/Detail'
import Header from './Header'
import CastPeople from '../Routes/Detail/CastPeople/CastPeople'
import Error from './Error'
import SeasonDetail from '../Routes/Detail/SeasonDetail/'
import SuperSection from './SuperSection'
import OutsideClickHandler from 'react-outside-click-handler'

export default () => {
    const [state, setState] = useState(false)

    return (
        <Router>
            <OutsideClickHandler onOutsideClick={() => setState(prev => !prev)}>
                <Header outsideClick={state} />
            </OutsideClickHandler>
            <Switch>
                <Route path='/' exact component={Home} />
                <Route path='/tv/' exact component={TV} />
                <Route path='/search/' exact component={Search} />
                <Route path='/search/:term/' component={Search} />
                <Route path='/tv/:id/seasons/:season/:title/' component={SeasonDetail} />
                <Route path='/person/:id/' component={CastPeople} />
                <Route path='/:type/sub/:section/:search' component={SuperSection} />
                <Route path='/:type/sub/:section/' component={SuperSection} />
                <Route path='/:type/:id/' component={Detail} />
                <Route path='/error/' exact component={Error} />
                <Redirect from='*' to='/error/' />
            </Switch>
        </Router>)
}



